import { cn } from '@/lib/utils'

/** Changes within this band are treated as noise (holidays, small samples). */
export const PERIOD_CHANGE_SIMILAR_THRESHOLD = 10

type PeriodChangeCaptionProps = {
  change: number
  className?: string
  /** When true, wrap in a light slate pill for denser metric rows. */
  pill?: boolean
}

/**
 * Neutral period-over-period caption. Avoids red/green judgment for routine dips.
 */
export function PeriodChangeCaption({
  change,
  className,
  pill = false,
}: PeriodChangeCaptionProps) {
  const abs = Math.abs(change)
  const isSimilar = abs < PERIOD_CHANGE_SIMILAR_THRESHOLD

  const label = isSimilar
    ? 'Similar to last period'
    : `${change > 0 ? '+' : '−'}${abs}% vs last period`

  return (
    <p
      className={cn(
        'text-sm text-slate-500 font-medium',
        pill && 'inline-flex w-fit px-2.5 py-1 rounded-md bg-slate-50 text-xs',
        className
      )}
    >
      {label}
    </p>
  )
}
